import {
  APP_VERSION,
  DOWNLOAD_URL,
  MANUAL_URL,
  SUPPORT_URL,
} from '../../shared/site-config'

const resources = [
  {
    label: 'WINDOWS APP',
    title: 'DSM Editor 다운로드',
    description: 'DSM Editor 최신 배포 파일을 내려받습니다.',
    action: '프로그램 다운로드',
    href: DOWNLOAD_URL,
    primary: true,
  },
  {
    label: 'USER GUIDE',
    title: '기능 및 사용 설명서',
    description: '기능별 사용 방법과 작업 순서를 설명서에서 확인합니다.',
    action: '설명서 열기',
    href: MANUAL_URL,
  },
  {
    label: 'SUPPORT',
    title: '문의 및 지원',
    description: '프로그램 사용 중 문의가 필요하면 지원 페이지를 이용합니다.',
    action: '지원 페이지 열기',
    href: SUPPORT_URL,
  },
]

export default function ResourcesPage() {
  return (
    <section className="resources-page section-container">
      <div className="section-heading narrow">
        <span className="eyebrow">DOWNLOAD &amp; GUIDE</span>
        <h1>필요한 자료를 한곳에서</h1>
        <p>프로그램 설치 파일, 사용 설명서, 문의 채널을 바로 이용할 수 있습니다.</p>
      </div>

      <div className="resource-grid">
        {resources.map((resource) => (
          <article className="resource-card" key={resource.label}>
            <span>{resource.label}</span>
            <div>
              <h2>{resource.title}</h2>
              <p>{resource.description}</p>
            </div>
            <a
              className={`button ${resource.primary ? 'button-primary' : 'button-secondary'}`}
              href={resource.href}
              target="_blank"
              rel="noreferrer"
            >
              {resource.action}
              <span aria-hidden="true">↗</span>
            </a>
          </article>
        ))}
      </div>

      <div className="download-note">
        <div>
          <span>현재 안내 버전</span>
          <strong>v{APP_VERSION}</strong>
        </div>
        <p>
          다운로드 파일은 Google Drive에서 제공됩니다. 브라우저의 파일 저장 안내가 나타나면
          저장 후 실행하세요.
        </p>
      </div>
    </section>
  )
}
